import React from 'react'
import useAuthenticationStore from './Store'
import { Logo } from '@careevolution/design-system'
import LocalizedText from '../../presentational/LocalizedText'
import { ProductNames } from './Authentication'
import './LoginHeader.css';

interface LoginHeaderProps {
  productName: string;
}


const LoginHeader: React.FC<LoginHeaderProps> = ({ productName }) => {
  const { state } = useAuthenticationStore()
  const { project } = state;

  let productLogo = null;
  if (productName === ProductNames.MyDataHelps) {
    productLogo = <Logo className="ce-brand-logo" brand="MyDataHelps" color="var(--ce-grey-55)" style='default' />
  } else if (productName === ProductNames.MyFHR) {
    productLogo = <img src="https://rkstudio-customer-assets.s3.amazonaws.com/CareEvolution/Images/myfhr-desaturated.png" alt="MyFHR" className="ce-brand-logo" />
  }

  return (
    <header className="ce-brand" >
      <div className='ce-brand-content'>
        {project &&
          <span className="project-hosting"> {project?.Name} <LocalizedText textKey="participant-login-is-powered-by" /> </span>
        }
        {productLogo}
      </div>
    </header >
  )
}

export default LoginHeader